import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectOrganizationUrlSlug } from '@state/organization/organization.selectors';
import { selectAuthUser } from '@state/auth/auth.selectors';

@UntilDestroy()
@Component({
  selector: 'app-shared-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  @Input({ required: true }) items: { label: string; path?: string }[] = [];
  @Input({ required: true }) addMarketplace = false;

  protected marketplacePath = '/';
  protected marketplaceLabel = 'Marketplace';

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.store
          .select(selectOrganizationUrlSlug)
          .pipe(untilDestroyed(this))
          .subscribe((urlSlug) => {
            if (
              urlSlug &&
              urlSlug !== user?.organization?.shortName?.toLowerCase()
            ) {
              this.marketplaceLabel = 'Marketplace';
              this.marketplacePath = `/o/${urlSlug}`;
            } else if (user?.organization && user?.organization.shortName) {
              this.marketplaceLabel = 'My Marketplace';
              this.marketplacePath = `/o/${user.organization.shortName.toLowerCase()}`;
            } else {
              this.marketplaceLabel = 'Marketplace';
              this.marketplacePath = '/';
            }
          });
      });
  }
}
